import {dispatchEvent} from './events-dispatcher';
import {channels as supportedChannels} from './channels';

export class Adapter {

  _channels = [];

  constructor(channels = []) {
    channels.forEach(this.addChannel);
  }

  addChannel = channel => {
    if (this.isChannelAlreadyInit(channel)) {
      return;
    }
    if (this.isChannelPredefined(channel)) {
      this.populateChannelEvents(channel);
    } else {
      this.registerChannel(channel);
    }
    if (this.isChannelValid(channel)) {
      this._channels.push(channel);
    }
  }

  trackEvent = (eventName, params, options) => {
    dispatchEvent(this._channels, eventName, params, options);
  }

  isChannelAlreadyInit = channel => this._channels
  .some(_channel => _channel.name === channel.name);

  isChannelPredefined(channel) {
    return supportedChannels[channel.name];
  }

  populateChannelEvents(channel) {
    channel.events = supportedChannels[channel.name];
  }

  isChannelValid(channel) {
    const hasName = channel.name;
    const hasReportFunction = channel.report;
    const hasEvents = channel.events && Object.values(channel.events).every(event => typeof (event) === 'function');
    return hasName && hasReportFunction && hasEvents;
  }

  registerChannel(channel) {
    if (this.isChannelValid(channel)) {
      supportedChannels[channel.name] = channel.events;
    }
  }
}



// WEBPACK FOOTER //
// ./privates/Adapter.js